// React
import { Col, Row } from 'reactstrap';
import React, { useState } from 'react';

export const HeaderInvoice = ({
  id,
  name,
  status,
  canEdit,
  statusColor,
  validation,
  cancellation,
  numberContract,
}) => {
  const [viewCancel, setViewCancel] = useState(false);

  const toggleAlertCancel = () => {
    setViewCancel(!viewCancel);
  };

  const convertDateToBrazilFormat = (date) => {
    let rawDate = date ? date.slice(0, 10) : '';
    const hour = date ? date.slice(10, 16) : '';

    if (rawDate !== null) {
      const [year, month, day] = rawDate.split('-');

      const result = [day, month, year].join('/');
      return result + hour;
    }
    return null;
  };

  return (
    <>
      <Row
        style={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Col
          md={3}
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <img src={process.env.REACT_APP_LOGO_DARK} width={200} alt="logo" />
        </Col>
        <Col
          md={7}
          style={{
            marginTop: 20,
          }}
        >
          <h2 className="mb-3">
            <small>Proposta de adesão</small>
          </h2>
          <div
            className="alert alert-primary alert-label-icon rounded-label shadow "
            role="alert"
            style={{
              width: '70%',
            }}
          >
            <i className="ri-user-2-fill label-icon"></i>
            <strong>Titular</strong>: {name} <br />
            {id && (
              <strong>Número do Cartão: {validation.values.cardNumber}</strong>
            )}
          </div>
        </Col>
      </Row>

      <div
        style={{
          position: 'absolute',
          right: 50,
          top: 30,
          WebkitUserSelect: ' none',
          msUserSelect: 'none',
          userSelect: 'none',
        }}
      >
        <h5 className="text-primary text-end">
          {id ? `Número ${numberContract}` : 'Nova Proposta'}
        </h5>

        <div
          className={`badge badge-soft-${statusColor}`}
          style={
            status === 'Cancelado'
              ? {
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '11px',
                }
              : {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '11px',
                }
          }
          onMouseLeave={
            status === 'Cancelado' ? () => toggleAlertCancel() : null
          }
          onMouseEnter={
            status === 'Cancelado' ? () => toggleAlertCancel() : null
          }
        >
          {status}

          {status === 'Cancelado' && (
            <i className="ri-information-line ps-2"></i>
          )}
        </div>
      </div>

      {viewCancel && (
        <div
          role="alert"
          className="alert alert-danger alert-border-left alert-dismissible fade shadow show"
          style={{
            position: 'absolute',
            minWidth: '200px',
            right: 50,
            top: 90,
          }}
        >
          <strong>Motivo do cancelamento: </strong>{' '}
          {cancellation?.reason || 'Sem motivo'}
          <br />
          {cancellation?.user_name && <strong>Cancelado por: </strong>}
          {cancellation?.user_name && `${cancellation?.user_name}`}
          <br />
          <strong>Data: </strong>{' '}
          {cancellation.created_at
            ? convertDateToBrazilFormat(cancellation.created_at)
            : 'Sem registro de data'}
        </div>
      )}
    </>
  );
};
